import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../utils/styledComponent';
import theme from '../../theme';

const TONE_BACKGROUNDS = {
  success: theme.colors.success,
  muted: theme.colors.textMuted,
  pending: theme.statusPillTones['in-progress'].softBg,
};

const toneStyles = Object.keys(TONE_BACKGROUNDS).reduce((acc, tone) => {
  acc[`&.tone-${tone}`] = { background: TONE_BACKGROUNDS[tone] };
  return acc;
}, {});

const StyledSpan = styledComponent('span', {
  flex: 'none',
  width: theme.sizes.stopBadgeSize,
  height: theme.sizes.stopBadgeSize,
  borderRadius: theme.radii.circle,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: theme.typography.label.fontSize,
  fontWeight: theme.fontWeights.semibold,
  color: theme.colors.white,
  ...toneStyles,
});

function StopBadge({ tone, children, ariaLabel, title, dataTestId }) {
  return (
    <StyledSpan
      className={`tone-${tone}`}
      aria-label={ariaLabel}
      title={title}
      data-testid={dataTestId}
    >
      {children}
    </StyledSpan>
  );
}

StopBadge.propTypes = {
  tone: PropTypes.oneOf(Object.keys(TONE_BACKGROUNDS)),
  children: PropTypes.node,
  ariaLabel: PropTypes.string,
  title: PropTypes.string,
  dataTestId: PropTypes.string,
};

StopBadge.defaultProps = {
  tone: 'success',
  children: null,
  ariaLabel: undefined,
  title: undefined,
  dataTestId: undefined,
};

export default StopBadge;
